<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="로그인" :type="'home'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <template v-if="guestShow">
            <div class="titArea mt0 ac">
              <h2 class="titH3">
                <span class="pointC3">비회원</span>
                도 즉시할인 받고 렌탈하세요!
              </h2>
              <div class="img">
                <img style="width: 56%; max-width: 190px" src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1613627246606_coupon_pack.png" />
              </div>
              <p class="desc">
                렌탈 진행 시,
                <span class="pointC3 medium">간편회원가입</span>
                만 하면
                <br />
                최대 할인쿠폰이 자동으로 적용돼요!
              </p>
            </div>
            <div class="btnArea mb40 mt20">
              <button @click="goNextPage" type="button" class="btn_h">최대 할인받고 렌탈하기</button>
            </div>

            <div class="titArea mt0">
              <h2 class="titH3">이미 회원이세요?</h2>
            </div>
          </template>
          <div class="formArea login">
            <ValidationObserver ref="form">
              <span class="label blind">아이디</span>
              <ValidationProvider name="아이디" rules="required" vid="userId">
                <input
                  type="text"
                  autocapitalize="off"
                  autocomplete="off"
                  id="ipt1_1"
                  class="ipt id"
                  placeholder="아이디를 입력해주세요."
                  title="아이디 입력(아이디를 입력해주세요.)"
                  value=""
                  v-model="userId"
                  v-skipOfMax
                  maxlength="20"
                  nextTarget="ipt2"
                />
              </ValidationProvider>

              <span class="label blind">비밀번호</span>
              <ValidationProvider name="비밀번호" rules="required" vid="password">
                <input
                  type="password"
                  id="ipt2"
                  class="ipt pw"
                  placeholder="비밀번호를 입력해주세요."
                  title="비밀번호 입력(비밀번호를 입력해주세요.)"
                  value=""
                  v-model="password"
                />
              </ValidationProvider>
            </ValidationObserver>
          </div>

          <div class="btnArea">
            <button type="button" class="btn_p" @click="login" :disabled="!inputCheck">로그인</button>
          </div>
          <div class="linkGroup ac">
            <button type="button" class="links" @click="$router.push('/login/findId')">아이디 찾기</button>
            <button type="button" class="links" @click="$router.push('/login/findPwd')">비밀번호 찾기</button>
            <button v-if="!guestShow" type="button" class="links" @click="join">
              회원가입
              <span class="bubbleMsg blue"><span>10만원 쿠폰 증정</span></span>
            </button>
          </div>
        </section>

        <section v-if="!guestShow">
          <div class="banner">
            <ul class="slideList">
              <li>
                <a @click="join">
                  <img
                    src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1606184755483_temp_banner_login.png"
                    alt="회원가입하고 10만원 할인혜택 받으세요!"
                  />
                </a>
              </li>
            </ul>
          </div>
        </section>
        <section class="snsArea">
          <p class="txtM" v-if="imsi">SNS 간편 로그인</p>
          <div class="snsGroup" v-if="imsi">
            <button type="button" class="snsBtn_ka on" @click="loginWithKakao">
              <span class="blind">카카오톡</span>
            </button>
            <button type="button" class="snsBtn_fb on" id="fb-root" @click="FBLogin">
              <span class="blind">페이스북</span>
            </button>
            <button type="button" class="snsBtn_nv on" @click="NVLogin">
              <span class="blind">네이버</span>
            </button>
          </div>

          <div v-if="!guestShow">
            <a href="javascript:void(0);" class="links arrow txtM" @click="goNextPage">비회원 주문 {{ geustText }}</a>
          </div>
          <!--<div>
            {{ log }}
          </div>-->
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>

    <ChangePwdPop v-if="changePwdPop" :userId="userId" :token="token" @changeLater="changeLater" @close="close"></ChangePwdPop>

    <InactiveAccountPop v-if="inactiveAccountPop" :lockDate="lockDate" @activeAccount="activeAccount" @close="close"></InactiveAccountPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import { isEmpty } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import ChangePwdPop from '@/components/popup/ChangePwdPop';
import InactiveAccountPop from '@/components/popup/InactiveAccountPop';
import { INPUT_INFO_CHECK } from '@/store/message.type';
const baseUrl = process.env.VUE_APP_BASE_URL;

export default {
  name: 'login',
  components: {
    MessagePop,
    ChangePwdPop,
    InactiveAccountPop,
  },
  props: ['redirect', 'param'],
  created() {
    // TODO 아이폰 심사관련 로직 확인 필요
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) this.imsi = false;
    console.log(this.$route.params);
  },
  mounted() {
    if (this.userId != '' && this.password != '') {
      this.inputCheck = true;
    } else {
      this.inputCheck = false;
    }

    console.log(this.redirect + ' >>> test');
    // console.log(this.$route.query);

    // sns 페이지 이동시 code 및 state 값을 받아서 로그인 혹은 회원 가입 로직 태움
    this.log = window.document.location.href;
    if (this.$route.query.state && this.$route.query.code) {
      this.snsLogin(this.$route.query.state, this.$route.query.code);
    }

    this.paymentInfo = {
      productCode: this.$route.params.productCode,
      color: this.$route.params.productColors,
      coupon: this.$route.params.coupon,
      orderId: null,
    };

    this.orderCommInfo = {
      colorCode: this.$route.params.colorCode,
      productCode: this.$route.params.productCode,
      internalProdCode: this.$route.params.internalProdCode,
      orderId: '', // 주문번호
      orderStatus: 'RSTA00PR', // 내부 상태 구분값 (RSTA00RP: 주문접수 완료, RSTA00PR: 사전주문접수)
      safekey: '', // 신용조회 후 발급받은 세이프키
      saleType: 'RORT00GE', // 주문구분 (렌탈: RORT00GE, 일시불: RORT00SE)
    };

    if (this.$route.params.nextPage) {
      if (this.$route.params.nextPage == 'paymentGuestMain') {
        this.geustText = '하기';
        this.guestTarget = 'paymentGuestMain';
        this.$cookies.set('paymentInfo', this.paymentInfo, '1min');
      } else if (this.$route.params.nextPage == 'guestStep1') {
        this.guestShow = true;
        this.geustText = '하기';
        this.guestTarget = 'guestStep1';
        this.$cookies.set('orderCommInfo', this.orderCommInfo, '1min');
      }
    } else {
      //this.$cookies.remove('orderCommInfo');
      //this.$cookies.remove('paymentInfo');
    }

    //카카오 js import
    this.$loadScript('https://developers.kakao.com/sdk/js/kakao.js')
      .then(() => {
        console.log('kakao');
      })
      .catch(() => {
        // Failed to fetch script
        console.log('error');
      });
  },
  beforeDestroy() {
    window.localStorage.removeItem('login');
  },
  data() {
    return {
      imsi: true,
      headerTitle: '로그인',
      userId: '',
      password: '',
      // TODO 비회원 주문조회 / 렌탈주문시에 따른 분기
      geustText: '조회', // 조회 -> 비회원 렌탈 주문시 -> 하기
      guestTarget: 'guestOrder', // 렌탈주문시에 따른 분기 경로
      userInfo: null, // 로그인 정보
      component: null, // 팝업종류
      msg: null, // 팝업용 메세지
      messagePop: false,
      changePwdPop: false,
      inactiveAccountPop: false,
      token: null,
      log: '',
      naverLogin: null,
      k_callback_url: baseUrl + 'login',
      inputCheck: false,
      lockDate: '12313',
      paymentInfo: null, // PDP 일시불 옵션정보
      orderCommInfo: null, // PDP 렌탈 옵션정보
      guestShow: false, // 비회원 렌탈 프로세스
    };
  },
  watch: {
    userId() {
      if (this.userId != '' && this.password != '') {
        this.inputCheck = true;
      } else {
        this.inputCheck = false;
      }
      console.log('test>>> userID');
    },
    password() {
      if (this.userId != '' && this.password != '') {
        this.inputCheck = true;
      } else {
        this.inputCheck = false;
      }
      console.log('test>>> password');
    },
  },
  methods: {
    FBLogin() {
      window.document.location.replace(
        'https://www.facebook.com/v8.0/dialog/oauth?client_id=2645885762390110&state=SHTP0005&redirect_uri=' + this.k_callback_url,
        // 'https://www.facebook.com/v8.0/dialog/oauth?client_id=' +
        //   process.env.VUE_APP_FACEBOOK +
        //   '&state=SHTP0005&redirect_uri=' +
        //   this.k_callback_url,
      );
    },
    NVLogin() {
      window.document.location.replace(
        'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=ycXetDw9e4ZFftBW2aVj&state=SHTP0002&redirect_uri=' +
          this.k_callback_url,
        // 'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=' +
        //   process.env.VUE_APP_NAVER +
        //   '&state=SHTP0002&redirect_uri=' +
        //   this.k_callback_url,
      );
    },
    loginWithKakao() {
      if (window.Kakao.isInitialized() === false) {
        console.log('카카오초기화');
        window.Kakao.init('845cf4cac5c87dd59475170f8bec7a76');
      }
      //window.Kakao.init(process.env.VUE_APP_KAKAO);
      window.Kakao.Auth.authorize({
        redirectUri: this.k_callback_url,
        state: 'SHTP0001',
      });
    },
    logoutKakao: function () {
      let kakaoAPI = window.Kakao;
      if (!kakaoAPI.Auth.getAccessToken()) {
        //test
        alert('Not logged in.');
        return;
      }
      kakaoAPI.Auth.logout(function () {
        alert('logout ok\naccess token -> ' + kakaoAPI.Auth.getAccessToken());
      });
    },
    snsLogin(state, code) {
      //회원 여부 체크
      // console.log(type + '//' + code);
      ApiService.service('GET', 'user/snsInfo/' + state + '/code/' + code)
        .then(({ data }) => {
          // console.log(data);
          if (data.isSucceed) {
            if (data.result.error || data.result.id == '') {
              this.msg = '간편 로그인 시도에 실패했습니다.<br>다시 요청해주세요.';
              this.messagePop = true;
            } else {
              // console.log(data.result.id);
              // console.log(data.result.userYn);
              //회원 여부 확인
              if (data.result.userYn == 'N') {
                this.$router.replace({ name: 'snsJoinStep1', params: { snsType: state, snsId: data.result.id } });
              } else {
                //로그인 로직
                this.token = data.result.loginInfo.token;
                console.log(this.token);
                // 토큰 저장
                this.$refs.header.pushUpdate(null, data.result.loginInfo.userInfoDto.userId);
                JwtService.saveToken(this.token);
                console.log(data.result.loginInfo.userInfoDto);
                JwtService.setUserInfo(data.result.loginInfo.userInfoDto);
                // 헤더 설정
                // ApiService.setHeader();
                if (data.result.isRestAccount == 'Y') {
                  // SNS 휴면 계정 체크
                  this.component = InactiveAccountPop;
                  this.inactiveAccountPop = true;
                } else {
                  // TODO userInfo 데이터 저장 확인
                  this.loginPageMove();
                }
              }
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async login() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          // TODO 로그인 API 호출
          this.$refs.header.loadingStart();
          await ApiService.service('POST', 'user/login', {
            request: {
              password: this.password,
              userId: this.userId,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              // console.log(data);

              if (data.isSucceed) {
                this.token = data.result.token;
                // console.log(this.token);
                // console.log(data.result.userInfoDto);
                // console.log(data.result.userInfoDto.lockDate);

                // SHA-256 관련 팝업처리
                if (data.result.needToChangePassword == 'S') {
                  this.msg = `
                    <p class="txt0">비밀번호 재설정 안내</p>
								    <p class="txt1">웰릭스렌탈몰 APP 신규 출시에따라<br>회원님의 계정은 <span class="bold">비밀번호 재설정</span>이 필요합니다.</p>
                    <p class="txt1 mt5"><span class="bold">[비밀번호 찾기]로 </span>진입 후,<br><span class="bold">본인확인 > 비밀번호를 재설정</span> 해주시기 바랍니다.</p>
                    <p class="txt1 mt5">비밀번호 설정 후 로그인하셔야<br/>정상적으로 서비스 이용이 가능합니다.</p>
                    `;
                  this.errorCode = '-10023';
                  this.messagePop = true;
                } else if (data.result.isRestAccount == 'Y') {
                  JwtService.saveToken(this.token);
                  //JwtService.setUserInfo(data.result.userInfoDto);
                  this.lockDate = data.result.userInfoDto.lockDate;
                  this.component = InactiveAccountPop;
                  this.inactiveAccountPop = true;
                } else if (data.result.needToChangePassword == 'Y') {
                  // 자동로그인 해제
                  //JwtService.logout();
                  JwtService.saveToken(this.token);
                  JwtService.setUserInfo(data.result.userInfoDto);

                  this.component = ChangePwdPop;
                  this.changePwdPop = true;
                } else {
                  // 토큰 및 유저 정보 저장
                  this.$refs.header.pushUpdate(null, data.result.userInfoDto.userId);
                  JwtService.saveToken(this.token);
                  JwtService.setUserInfo(data.result.userInfoDto);
                  this.loginPageMove();
                }
              } else {
                if (!isEmpty(data.error)) {
                  this.msg = data.error;
                  this.errorCode = data.errorCode;
                  this.messagePop = true;
                }
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            })
            .finally(() => {
              this.$refs.header.loadingEnd();
            });
        }
      });
    },
    async changeLater() {
      // 90뒤 변경 API 호출
      await ApiService.service('PUT', 'user/auth/password/period', {
        request: {
          userId: this.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          // console.log(data);

          if (data.isSucceed) {
            this.loginPageMove();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    async activeAccount() {
      await ApiService.service('PUT', 'user/auth/account/releaseRest', {
        request: {
          userId: this.userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          // console.log(data);

          if (data.isSucceed) {
            JwtService.logout();
            this.inactiveAccountPop = false;
            this.msg = `휴먼해제 되었습니다.`;
            this.messagePop = true;
            this.userId = '';
            this.password = '';
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    loginPageMove() {
      if (!isEmpty(this.redirect)) {
        this.$router.replace({ name: this.redirect, params: this.param });
      } else {
        if (this.$route.params.nextPage) {
          if (this.guestTarget == 'guestStep1') {
            this.$router.replace({ name: 'memberMain', params: this.$route.params });
          } else if (this.guestTarget == 'paymentGuestMain') {
            this.$router.replace({ name: 'paymentMemberMain', params: this.$route.params });
          } else {
            this.$router.replace({ name: this.guestTarget, params: this.$route.params });
          }
        } else {
          this.$router.replace('/');
        }
      }
    },
    goNextPage() {
      if (this.guestShow) {
        this.$router.push({ name: this.guestTarget, params: this.$route.params });
      } else {
        this.$router.push({ name: this.guestTarget, params: this.$route.params });
      }
    },
    close() {
      if (this.inactiveAccountPop) JwtService.logout();
      this.messagePop = false;
      this.changePwdPop = false;
      this.inactiveAccountPop = false;
      //this.userId = '';
      //this.password = '';
      if (this.errorCode == '-10023') {
        // 비밀번호 5회실패시
        this.$router.push('/login/findPwd');
      }
    },
    join() {
      if (this.$route.params.nextPage) {
        if (this.$route.params.nextPage == 'paymentGuestMain') {
          this.$router.push({ name: 'joinStep1', params: { paymentInfo: this.paymentInfo } });
        } else if (this.$route.params.nextPage == 'guestStep1') {
          this.$router.push({ name: 'joinStep1', params: { orderCommInfo: this.orderCommInfo } });
        }
      } else {
        this.$router.push('/join/joinStep1');
      }
    },
  },
};
</script>
